'use strict';

import {EvaluationBaseCtrl} from "../applications/evaluationbasectrl.js";

import {periodicReportChecklistModel} from '../../models/periodicreportchecklistmodel.js';

export class PeriodicReportChecklistCtrl extends EvaluationBaseCtrl
{
//	showRequire = true;
	postConstruct(){
		let raw = this.jsDataService.get('checklistData', {}).status_time;
		let raw2 = this.jsDataService.get('checklistData', {}).status_time2;
		this.checklist = new periodicReportChecklistModel(
			Object.assign({}, this.jsDataService.get('checklistData', {}), {
				statusTimeDate: new Date(raw * 1000),
				statusTimeDate2: new Date(raw2 * 1000)
			}),
			this.$filter,
			this.jsDataService
		);
		this.spec_calcRejected();
	}
	
	go2Url(urlString){
		this.$scope.goUrl(urlString);
	}
	
	completeChecklist(ev, form){
		this.showRequire = true;
		this.$timeout(()=>{
			if(form.$invalid){
				this.notify(this.$filter('tr')('err_check_required_fields'), true);
			}
			else{
				const confirmTexts = this.jsDataService.get('checklistConfirmTexts');
				const confirm = this.$mdDialog.confirm()
					.title(confirmTexts.title)
					.htmlContent(confirmTexts.content)
					.ariaLabel(confirmTexts.title)
					.targetEvent(ev)
					.ok(confirmTexts.ok)
					.cancel(confirmTexts.cancel);
				this.$mdDialog.show(confirm).then(() => {
					this.$scope.basicHttpConfigProcess({
						url: this.jsDataService.get('cfgConfirmUrl'),
						method: 'GET',
						params: {}
					}).then((results) => {
						if(results.data.success){

						}
					});
				}, () => {});
			}
		});
	}
	
	autosavePostFields(){
		return {
			id: this.checklist.id,
			data_value: this.checklist.data_value.getAllData()
		};
//		return this.checklist.data_value.getAllData();
	}
	
	confirmChecklist(ev){
		this.$timeout(()=>{
			const confirmTexts = this.jsDataService.get('checklistConfirmTexts');
			const confirm = this.$mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(ev)
				.ok(confirmTexts.ok)
				.cancel(confirmTexts.cancel);
			this.$mdDialog.show(confirm).then(() => {
				this.$scope.basicHttpConfigProcess({
					url: this.jsDataService.get('cfgConfirmUrl'),
					method: 'GET',
					params: {}
				}).then((results) => {
					if(results.data.success){

					}
				});
			}, () => {});			
			
		});		
	}
	
	refuseDialogCtrl($scope, $mdDialog) {
		$scope.comment = '';
		$scope.close = function () {
			$mdDialog.cancel();
		};

		$scope.submitDialog = function () {
			$mdDialog.hide({
				comment: $scope.comment
			});
		};
	}
	
	refuseChecklist(ev){
		this.$mdDialog.show({
			controller: ["$scope", "$mdDialog", this.refuseDialogCtrl],
			templateUrl: 'projects/periodic_checklist_refuse.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose: false,
			fullscreen: true
//				locals: {
//					evaluation: this.evaluation
//				}
		}).then((results) => {
			const url = this.jsDataService.get('cfgRefuseUrl');
			if (url) {
				this.$scope.basicHttpConfigProcess({
					url: url,
					method: 'POST',
					data: results
				});
			}
		}, () => {
		});

	}
	
	spec_calcRejected(){
		if(typeof(this.checklist.data_value.conclusion.rejected) !== 'undefined'){
			this.checklist.data_value.conclusion.rejected.value = 0;
			if(this.checklist.data_value.conclusion.requested?.value > 0){
				if(this.checklist.data_value.conclusion.approved?.value > 0){
					if( this.checklist.data_value.conclusion.approved?.value < this.checklist.data_value.conclusion.requested?.value){
						this.checklist.data_value.conclusion.rejected.value = (this.checklist.data_value.conclusion.requested?.value - this.checklist.data_value.conclusion.approved?.value);
					}
				}
				else{
					this.checklist.data_value.conclusion.rejected.value = this.checklist.data_value.conclusion.requested?.value;
				}
			}
		}
	}
	
}
